import { initializeApp } from "firebase/app";

// TODO: Add prod domain
const firebaseConfig =
    "cms.fantasychess.app" === window.location.hostname
        ? {
              apiKey: "AIzaSyCF-QSpPjG138vhaoYmc_jxvITygveMwAE",
              authDomain: "fantasy-chess-396614.firebaseapp.com",
              projectId: "fantasy-chess-396614",
              storageBucket: "fantasy-chess-396614.appspot.com",
              messagingSenderId: "413376018376",
              appId: "1:413376018376:web:9259eb5ce63103972e72fd",
          }
        : {
              apiKey: "AIzaSyCIecGpT29Skxuk3_ysYeg2M9I8YQjTN_M",
              authDomain: "fantasy-chess-test.firebaseapp.com",
              projectId: "fantasy-chess-test",
              storageBucket: "fantasy-chess-test.appspot.com",
              messagingSenderId: "965360071775",
              appId: "1:965360071775:web:581442e8b88dbba36f57ea",
          };

export const firebaseApp = initializeApp(firebaseConfig);
